import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ContractInboundPhone } from "../_types/contract-inbound-phone";

@Injectable({
  providedIn: 'root',
})
export class ContractInboundPhonesService extends Service<ContractInboundPhone> {
  public override type = 'contractsInboundPhones';
  public override url = 'attendance/contractsInboundPhones';
}